var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import cloneDeep from 'lodash.clonedeep';
import { CellSelection } from 'prosemirror-tables';
import { canSplitCell, tableOperation } from './utils';
// dynamically change the context menu of the table
var formatMenu = function (editor, data) {
    var sel = editor.view.state.selection;
    var defaultMenus = cloneDeep(data);
    var menus = defaultMenus.filter(function (menu) { return typeof menu === 'string' || menu.key !== 'mergeCells'; });
    if (sel instanceof CellSelection && sel.ranges.length > 1) {
        menus = defaultMenus.filter(function (menu) { return typeof menu === 'string' || menu.key !== 'splitCell'; });
    }
    else {
        if (!canSplitCell(editor)) {
            var index = menus.findIndex(function (menu) { return typeof menu !== 'string' && menu.key === 'splitCell'; });
            menus.splice(index, 2);
        }
        if (sel.from === sel.to) {
            menus = menus.map(function (values) {
                if (typeof values !== 'string' && (values.key === 'cut' || values.key === 'copy')) {
                    return __assign(__assign({}, values), { disable: true });
                }
                return values;
            });
        }
    }
    return menus;
};
/**
 * @param cursorRect
 * @param domRect
 */
var calculateMenuPosition = function (cursorRect, domRect) {
    var clientY = cursorRect.clientY, clientX = cursorRect.clientX;
    var width = domRect.width, height = domRect.height;
    var prefixTop = (document.scrollingElement && document.scrollingElement.scrollTop) || 0;
    var top = clientY + prefixTop, left = clientX;
    if (clientY + height > window.innerHeight) {
        var offsetTop = 10;
        top = prefixTop - height + window.innerHeight - offsetTop;
        if (top < 0)
            top = 0;
    }
    if (clientX + width > window.innerWidth) {
        left = window.innerWidth - width;
    }
    return {
        top: top,
        left: left,
    };
};
var defaultMenuLocale = {
    cut: 'cut',
    copy: 'copy',
    paste: 'paste',
    mergeCells: 'merge cells',
    splitCell: 'split cell',
    addColumnBefore: 'add column before',
    addColumnAfter: 'add column after',
    addRowBefore: 'add row before',
    addRowAfter: 'add row after',
    deleteRow: 'delete row',
    deleteColumn: 'delete column',
    deleteTable: 'delete table', // '删除表格',
};
var createMenu = function (localeConfig) {
    var locale = Object.assign({}, defaultMenuLocale, localeConfig);
    return [
        {
            name: locale.cut,
            key: 'cut',
            callback: tableOperation.cut,
        },
        {
            name: locale.copy,
            key: 'copy',
            callback: tableOperation.copy,
        },
        {
            name: locale.paste,
            key: 'paste',
            disable: true,
            tip: "\u8BF7\u4F7F\u7528 <b>" + (/Mac/.test(navigator.platform) ? '⌘+V' : 'Ctrl+V') + "</b> \u7C98\u8D34",
            callback: function () { },
        },
        '|',
        {
            name: locale.mergeCells,
            key: 'mergeCells',
            callback: tableOperation.mergeCells,
        },
        {
            name: locale.splitCell,
            key: 'splitCell',
            callback: tableOperation.splitCells,
        },
        '|',
        {
            name: locale.addColumnBefore,
            key: 'addColumnBefore',
            callback: tableOperation.addColumnBefore,
        },
        {
            name: locale.addColumnAfter,
            key: 'addColumnAfter',
            callback: tableOperation.addColumnAfter,
        },
        {
            name: locale.addRowBefore,
            key: 'addRowBefore',
            callback: tableOperation.addRowBefore,
        },
        {
            name: locale.addRowAfter,
            key: 'addRowAfter',
            callback: tableOperation.addRowAfter,
        },
        '|',
        {
            name: locale.deleteRow,
            key: 'deleteRow',
            callback: tableOperation.deleteRow,
        },
        {
            name: locale.deleteColumn,
            key: 'deleteColumn',
            callback: tableOperation.deleteColumn,
        },
        {
            name: locale.deleteTable,
            key: 'deleteTable',
            callback: tableOperation.deleteTable,
        },
    ];
};
export { calculateMenuPosition, canSplitCell, createMenu, formatMenu };
//# sourceMappingURL=menu-helper.js.map